export default __webpack_public_path__ + "static/media/face-shush.16741ad2.svg";